const WS_URL = process.env.REACT_APP_WS_URL || "ws://localhost:8000/ws/chat";

export function createWebSocketConnection(onMessageReceived) {
    const anonId = localStorage.getItem("anon_id") || "";
    const urlWithId = anonId ? `${WS_URL}?anon_id=${encodeURIComponent(anonId)}` : WS_URL;
    const socket = new WebSocket(urlWithId);

    socket.onopen = () => {
        console.log("Connected to WebSocket");
    };

    socket.onmessage = (event) => {
        let msg = event.data;
        let parsed = null;
        try {
            parsed = JSON.parse(msg);
        } catch {
            parsed = msg; // JSON이 아니면 일반 텍스트로 처리
        }
        onMessageReceived(parsed);
    };

    socket.onclose = () => {
        console.log("Disconnected from WebSocket");
    };

    return socket;
}
